import { c as e } from "react/compiler-runtime";
import { AuthError as t, InteractionStatus as n, LogLevel as r, createStandardPublicClientApplication as i } from "@azure/msal-browser";
import { MsalProvider as a, useMsal as o } from "@azure/msal-react";
import { createContext as s, useEffect as c, useState as l } from "react";
import u from "axios";
import { jsx as d } from "react/jsx-runtime";
//#region src/config/LogoutOnAuthErrors.ts
var f = [
	"invalid_grant",
	"interaction_required",
	"no_tokens_found"
], p = async (e, n, r) => {
	let i = {
		scopes: r,
		account: e
	};
	try {
		if (!e) throw await n.acquireTokenRedirect(i), Error("Redirecting for token acquisition");
		await Promise.resolve();
		let t = await n.acquireTokenSilent(i);
		if (!t.account) throw await n.acquireTokenRedirect(i), Error("Redirecting for token acquisition");
		return t.accessToken;
	} catch (e) {
		throw e instanceof t && f.includes(e.errorCode) ? (await n.logoutRedirect(), Error("Logged out due to authentication error")) : (console.error(e), Error("Failed to acquire token"));
	}
}, m = /* @__PURE__ */ function(e) {
	return e.MsalInitialized = "MsalInitialized", e.AuthRedirectionsComplete = "AuthRedirectionsComplete", e.Ready = "Ready", e;
}(m || {}), h = async (e, t) => {
	try {
		let n = await u.get(`${e}/heartbeat`, { headers: { Authorization: `Bearer ${t}` } });
		if (n.status !== 204) return console.error("Heartbeat failed with status code:", n.status), !1;
	} catch (e) {
		return console.error("Error performing heartbeat:", e), !1;
	}
	return !0;
}, g = (e) => {
	let t = e?.idTokenClaims;
	if (t) return {
		firstName: t?.given_name,
		lastName: t?.family_name,
		fullName: `${t?.given_name} ${t?.family_name}`,
		user: t?.user,
		userType: t?.userType,
		agent: t?.agent,
		agency: t?.agency,
		roles: t?.roles
	};
}, _ = (e) => {
	if (!e) throw console.error("Auth app URI is undefined"), Error("Auth app URI is undefined");
	return [`${e}/openid`];
}, v = (t) => {
	let r = e(24), { baseApiUri: i, authAppUri: a } = t;
	if (i == null || a == null) throw console.error("Base API URI or Auth app URI is undefined"), Error("Base API URI or Auth app URI is undefined");
	let [s, u] = l(m.MsalInitialized), { instance: d, accounts: f, inProgress: v } = o(), x = f == null || f.length === 0 ? void 0 : f[0], S;
	r[0] === a ? S = r[1] : (S = _(a), r[0] = a, r[1] = S);
	let C = S, w, T;
	r[2] !== s || r[3] !== v ? (w = () => {
		s === m.MsalInitialized && v === n.None && u(y);
	}, T = [s, v], r[2] = s, r[3] = v, r[4] = w, r[5] = T) : (w = r[4], T = r[5]), c(w, T);
	let E, D;
	r[6] !== x || r[7] !== i || r[8] !== d || r[9] !== s || r[10] !== v || r[11] !== C ? (E = () => {
		if (d && s === m.AuthRedirectionsComplete && v === n.None) {
			if (!i) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
			p(x, d, C).then((e) => {
				if (!e) throw console.error("No auth token available"), Error("No auth token available");
				h(i, e).then((e) => {
					if (!e) throw console.error("Heartbeat failed"), Error("Heartbeat failed");
					u(b);
				});
			});
		}
	}, D = [
		s,
		d,
		x,
		C,
		i,
		v
	], r[6] = x, r[7] = i, r[8] = d, r[9] = s, r[10] = v, r[11] = C, r[12] = E, r[13] = D) : (E = r[12], D = r[13]), c(E, D);
	let O;
	r[14] === x ? O = r[15] : (O = g(x), r[14] = x, r[15] = O);
	let k = O, A;
	r[16] !== x || r[17] !== d || r[18] !== s || r[19] !== C ? (A = s === m.Ready ? () => p(x, d, C) : void 0, r[16] = x, r[17] = d, r[18] = s, r[19] = C, r[20] = A) : A = r[20];
	let j = A, M;
	return r[21] !== j || r[22] !== k ? (M = [k, j], r[21] = j, r[22] = k, r[23] = M) : M = r[23], M;
};
function y(e) {
	return e === m.MsalInitialized ? m.AuthRedirectionsComplete : e;
}
function b(e) {
	return e === m.AuthRedirectionsComplete ? m.Ready : e;
}
//#endregion
//#region src/msal/AuthContext.ts
var x = s({
	getAuthToken: async () => {
		throw Error("getAuthToken not initialized");
	},
	userAccount: {}
}), S = (t) => {
	let n = e(6), { children: r, apiConfig: i } = t, [a, o] = v(i);
	if (!a || !o) return null;
	let s;
	n[0] !== o || n[1] !== a ? (s = {
		getAuthToken: o,
		userAccount: a
	}, n[0] = o, n[1] = a, n[2] = s) : s = n[2];
	let c = s, l;
	return n[3] !== c || n[4] !== r ? (l = /* @__PURE__ */ d(x.Provider, {
		value: c,
		children: r
	}), n[3] = c, n[4] = r, n[5] = l) : l = n[5], l;
}, C = ({ authClientId: e, authInstance: t, authDomain: n, authSignupSigninPolicyId: i, envSigninPrefix: a, authEnableLogs: o }) => {
	if (!e) throw Error("authClientId is not set");
	if (!t) throw Error("authInstance is not set");
	if (!n) throw Error("authDomain is not set");
	if (!i) throw Error("authSignupSigninPolicyId is not set");
	if (!a) throw Error("envSigninPrefix is not set");
	let s = o === "true";
	return {
		auth: {
			clientId: e,
			authority: `https://${t}/${n}/${i}`,
			knownAuthorities: [t],
			redirectUri: a
		},
		cache: { cacheLocation: "sessionStorage" },
		system: { loggerOptions: { loggerCallback: (e, t, n) => {
			if (s && !n) switch (e) {
				case r.Error:
					console.error(t);
					return;
				case r.Info:
					console.info(t);
					return;
				case r.Verbose:
					console.debug(t);
					return;
				case r.Warning:
					console.warn(t);
					return;
				default: return;
			}
		} } }
	};
}, w = (t) => {
	let n = e(9), { children: r, apiConfig: o } = t, [s, u] = l(void 0), f, p;
	if (n[0] === o ? (f = n[1], p = n[2]) : (f = () => {
		i(C(o)).then((e) => {
			u(e);
		});
	}, p = [o], n[0] = o, n[1] = f, n[2] = p), c(f, p), !s) return null;
	let m;
	n[3] !== o || n[4] !== r ? (m = /* @__PURE__ */ d(S, {
		apiConfig: o,
		children: r
	}), n[3] = o, n[4] = r, n[5] = m) : m = n[5];
	let h;
	return n[6] !== s || n[7] !== m ? (h = /* @__PURE__ */ d(a, {
		instance: s,
		children: m
	}), n[6] = s, n[7] = m, n[8] = h) : h = n[8], h;
}, T = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r }) => {
	let i = {};
	return e !== void 0 && (i["x-claim-userId"] = e), t !== void 0 && (i["x-claim-userType"] = t), n !== void 0 && (i["x-claim-agency"] = n), r !== void 0 && (i["x-claim-roles"] = r), i;
}, E = class {
	getAuthTokenFunction = void 0;
	devHeaders = {};
	constructor() {}
	transformOptions = async (e) => {
		if (!this.getAuthTokenFunction) throw Error("No getAuthTokenFunction has been provided");
		let t = await this.getAuthTokenFunction();
		return e.headers = {
			...e.headers,
			...this.devHeaders,
			Authorization: `Bearer ${t}`
		}, Promise.resolve(e);
	};
	setAuthConfig = (e, t) => {
		this.getAuthTokenFunction = e, this.devHeaders = T(t);
	};
	async transformResult(e, t, n) {
		let r = String(t.headers?.["content-type"] ?? "").toLowerCase(), i = t.data;
		return r.includes("application/json") && typeof i == "object" && i ? i : await Promise.resolve(n(t));
	}
}, D = /* @__PURE__ */ function(e) {
	return e.Director = "director", e.SalesAgent = "salesagent", e.Admin = "admin", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.BusinessManager = "businessmanager", e.AdminManager = "adminmanager", e.MarketingExpert = "marketingexpert", e.ListingsContributor = "listingscontributor", e.LaunchContributor = "launchcontributor", e.ContractsContributor = "contractscontributor", e.TransactionsContributor = "transactionscontributor", e.FinanceContributor = "financecontributor", e.WorkflowContributor = "workflowcontributor", e.Executive = "executive", e.SuperAdmin = "superadmin", e;
}({});
//#endregion
export { D as AgentRole, w as AgxAuth, x as AuthContext, E as AuthorizedApiBase, O as StaffRole };

//# sourceMappingURL=index.js.map